import {
    IBaseController,
    Inject,
    ISimpleControllerChildControllerConfiguration,
    ISimpleControllerConfiguration,
    ModelEvents,
    SimpleBaseController,
} from '@denishussar/html5-game-engine';
import { CrazyGamesAdsLogic } from '../../Logic/CrazyGames/CrazyGamesAdsLogic';
import { GameLogic } from '../../Logic/GameLogic';
import { AlbumsLibrary } from '../../Models/AlbumsLibrary';
import { GameModel, GameStateEnum } from '../../Models/GameModel';
import { FTUEGameScreenController } from '../Game/FTUEGameScreenController';
import { GameScreenController } from '../Game/GameScreenController';
import { AchievementScreenController } from './AchievementScreenController';
// import { AlbumScreenController } from './AlbumScreenController';
import { CatalogController } from './Catalog/CatalogController';
import { FTUEWinScreenController } from './FTUEWinScreenController';
import { MainScreenController } from './MainScreenController';
import { ShopLifeScreenController } from './ShopLifeScreenController';
import { ShopScreenController } from './ShopScreenController';
import { WinScreenController } from './WinScreenController';
import { Container, DisplayObject, Graphics, Point } from 'pixi.js';
import { SavesManager } from '../../../game/Managers/SavesManager';
import { GameEvent } from '../../Constants/GameEvent';
import gsap from 'gsap';
import { CrazyGamesAdsType } from '../../Common/CrazyGamesAds/CrazyGamesAds';
import {AdsLogic} from "../../Logic/Ads/AdsLogic";
import {ModalsNames} from "../../Common/MadalsManager/ModalsList";
import {LocalizationContents} from "../../LocalizationContents";
import {FTUEWelcomeModalController} from "../Modals/FTUEWelcomeModalController";
import {CatalogFolderController} from "./Catalog/CatalogFolderController";

const CONTROLLERS_MAP = {
    mainScreen: MainScreenController,
    // albumScreen: AlbumScreenController,
    shopScreen: ShopScreenController,
    shopLifeScreen: ShopLifeScreenController,
    catalogScreen: CatalogController,
    achievementScreen: AchievementScreenController,
};

const STATES_MAP = {
    mainScreen: GameStateEnum.main,
    albumScreen: GameStateEnum.album,
    shopScreen: GameStateEnum.shop,
    shopLifeScreen: GameStateEnum.shopLife,
    catalogScreen: GameStateEnum.catalog,
    achievementScreen: GameStateEnum.achievement,
};

export class ScreenManagerController extends SimpleBaseController {
    $model: GameModel;

    _overlayGraphics!: Graphics;

    constructor(
        @Inject options: any,
        @Inject private gameLogic: GameLogic,
        @Inject private adsLogic: AdsLogic,
        @Inject private saveManager: SavesManager,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('ScreenManagerController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {

        const childs = {};

        // for (const screenName in CONTROLLERS_MAP) {
        //     childs[screenName] = {
        //         controller: CONTROLLERS_MAP[screenName],
        //         model: screenName === 'shopLifeScreen' ? this.$model.shopModel : this.$model, //todo: rework
        //     };
        // }

        // childs['FTUEmainScreen'] = {
        //     controller: FTUEMainScreenController,
        //     model: this.$model
        // };

        return {
            childControllers: childs,
            modelWatch: {
                gameState: async (state: GameStateEnum, prevState: GameStateEnum) => {
                    if (state === prevState) return;
                    // const names = ['winScreen', 'gameScreen', 'mainScreen'];
                    // for (let i = 0; i < names.length; i++) {
                    //     const controller = this.$childControllers.get(names[i]);
                    //     if (controller) {
                    //         await this.fadeOut(controller.display);
                    //         console.warn("remove " + names[i]);
                    //         this.removeChildControllerByNameAsync(names[i]);
                    //     }
                    // }
                    const controllers = [];
                    this.$childControllers.items.forEach(child => {
                        controllers.push(child.controller);
                        // const visible = state === STATES_MAP[child.name];
                        // if (child.controller.visible !== visible) {
                        //     this.changeVisible(child.controller, visible);
                        // }
                    });

                    for (let i = 0; i < controllers.length; i++) {
                        await this.fadeOut(controllers[i].display, state === GameStateEnum.game);
                        this.removeChildController(controllers[i]);
                    }

                    switch (state) { //todo: refactor more
                        case GameStateEnum.game:
                            if (this.gameLogic.isFTUE) {
                                this.adsLogic.adsLogic?.gameplayStart();
                                this.createController(FTUEGameScreenController, 'gameScreen', this.$model);
                            } else {
                                this.adsLogic.adsLogic?.gameplayStart();
                                this.createController(GameScreenController, 'gameScreen', this.$model);

                                /*
                                if (!this.saveManager.hasAnatalyticFlag(AnalyticsEventEnum.loadGameSecond)) {
                                    this.saveManager.saveAnalyticFlag(AnalyticsEventEnum.loadGameSecond);
                                    this.analyticsService.sendEvent(AnalyticsEventEnum.loadGameSecond);
                                }
                                 */
                            }
                            break;

                        case GameStateEnum.main:
                            if (this.gameLogic.isFTUE) {
                                // setTimeout(() => {
                                //     this.gameLogic.modalsManager.show(ModalsNames.ftueWelcome,{
                                //         text: LocalizationContents.getText('BuyEmbroideryTitle'),
                                //     });
                                // }, 0);

                                await this.addChildControllerAsync({
                                    controller: FTUEWelcomeModalController,
                                    model: this.$model,
                                    options: {
                                        opacity: true,
                                    },
                                }, false, 'FTUEWelcomeModalController');

                                const imageID = localStorage.getItem("FTUE_CHOOSED_IMAGE");
                                if (imageID) {
                                    const ftuePicture = this.model.albumLibrary.getPictureData(`${AlbumsLibrary.PICTURE_FTUE}${imageID}`);

                                    if (ftuePicture) {
                                        this.gameLogic.setPicture(ftuePicture);
                                    }
                                }

                                const intervalID = setInterval(() => {
                                    if (window['gamePreloaderProgress'] !== -1) {
                                        window['gamePreloaderProgress'] = -1;
                                        clearInterval(intervalID);
                                    }
                                }, 2000);
                                break;
                            }

                            if (this.adsLogic.adsLogic?.gameplayRunning()) {
                                this.adsLogic.adsLogic?.gameplayStop();
                            }
                            const intervalID = setInterval(() => {
                                if (window['gamePreloaderProgress'] !== -1) {
                                    window['gamePreloaderProgress'] = -1;
                                    clearInterval(intervalID);
                                }
                            }, 2000);
                            // this.createController(MainScreenController, 'mainScreen', this.$model);
                            this.gameLogic.setState(GameStateEnum.catalog);
                            break;
                        case GameStateEnum.catalog:
                            this.createController(CatalogController, 'catalogue', this.$model);
                            //@ts-ignore
                            // this.$childControllers.get('catalogue').handleListClick('my_collection', false);
                            break;
                        case GameStateEnum.achievement:
                            this.createController(AchievementScreenController, 'achivement', this.$model);
                            break;
                        case GameStateEnum.shop:
                            this.createController(ShopScreenController, 'shop', this.$model);
                            break;
                        case GameStateEnum.shopLife:
                            this.createController(ShopLifeScreenController, 'shopLife', this.$model);
                            break;
                        case GameStateEnum.win:
                            const picture = this.gameLogic.getPicture();
                            if (picture && !!~picture.id.indexOf(AlbumsLibrary.PICTURE_FTUE) ) {
                                await this.addChildControllerAsync({
                                    controller: FTUEWinScreenController,
                                    model: this.$model,
                                    options: {
                                        opacity: true,
                                    },
                                }, false, 'winScreen');
                            } else {
                                await this.addChildControllerAsync({
                                    controller: WinScreenController,
                                    model: this.$model,
                                    options: {
                                        opacity: true,
                                    },
                                }, false, 'winScreen');
                            }

                            this.modelEvents.dispatch(this.$model, GameEvent.sceneOpen);

                            this.fadeIn(this.$childControllers.get('winScreen').display);
                            break;
                    }
                },
            },
        };
    }

    protected onInitialize(): void {
        // this.$childControllers.items.forEach(child => {
        //     child.controller.visible = false;
        // });

        this._overlayGraphics = new Graphics();
        this._overlayGraphics.alpha = 0;
        this.display.addChild(this._overlayGraphics);

        this.modelEvents.dispatch(this.model, GameEvent.preloaderComplete);

        this.gameLogic.setState(GameStateEnum.main);

        // HACK
        // window['gamePreloaderProgress'] = -1;
    }

    protected onResize(width: number, height: number, scale: number) {
        const topLeftPoint = this.display.toLocal(new Point(0, 0), this.renderer.stage);
        const bottomRightPoint = this.display.toLocal(new Point(width, height), this.renderer.stage);

        this._overlayGraphics.position.set(0, 0);//topLeftPoint.x, topLeftPoint.y);
        this._overlayGraphics.clear();
        this._overlayGraphics.beginFill(0x000000, 1);
        this._overlayGraphics.drawRect(topLeftPoint.x, topLeftPoint.y, bottomRightPoint.x * scale * 10, bottomRightPoint.y * scale * 10);
        this._overlayGraphics.endFill();
    }

    private changeVisible(controller: IBaseController, visible: boolean) {
        // gsap.killTweensOf(controller.display);
        this.display.addChild(controller.display);
        if (visible) {
            controller.display.alpha = 0;
            controller.visible = true;
            gsap.to(controller.display, { alpha: 1, duration: .3, ease: 'circ.in' });
        } else {
            gsap.to(controller.display, { alpha: 0, duration: .3, ease: 'circ.in' })
                .then(() => {
                    controller.visible = false;
                    controller.display.alpha = 1;
                });
        }
    }

    private createController(controller, name: string, model: any) {
        this.modelEvents.dispatch(this.$model, GameEvent.sceneOpen);

        this.addChildControllerAsync(<ISimpleControllerChildControllerConfiguration>{
            controller,
            model: model,
            options: { opacity: true },
        }, false, name).then((controller) => {
            this.fadeIn(controller.display, name === 'gameScreen');
        });
    }

    private async fadeIn(display: DisplayObject, withOverlay: boolean = false) {
        return new Promise<void>(resolve => {
            if (withOverlay) {
                display.alpha = 1;
                const container = new Container();

                this.display.addChild(container);
                this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);

                container.addChild(display);
                container.alpha = 0;
                container.scale.set(1.2);

                gsap.killTweensOf(this._overlayGraphics);
                gsap.to(this._overlayGraphics, {
                    duration: 0.3, alpha: 0, onComplete: async () => {
                        gsap.to(container.scale, { x: 1, y: 1, duration: .3, ease: 'circ.in' });
                        gsap.to(container, {
                            alpha: 1, duration: .3, ease: 'circ.in', onComplete: async () => {
                                this.display.addChild(display);
                                this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);
                                this.display.removeChild(container);

                                resolve();
                            },
                        });
                    },
                });
            } else {
                this._overlayGraphics.alpha = 0;

                display.alpha = 1;
                const container = new Container();

                this.display.addChild(container);
                this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);

                container.addChild(display);
                container.alpha = 0;
                container.scale.set(1.2);

                gsap.to(container.scale, { x: 1, y: 1, duration: .3, ease: 'circ.in' });
                gsap.to(container, {
                    alpha: 1, duration: .3, ease: 'circ.in', onComplete: async () => {
                        this.display.addChild(display);
                        this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);
                        this.display.removeChild(container);

                        resolve();
                    },
                });
            }
        });
    }

    private async fadeOut(display: DisplayObject, withOverlay: boolean = false) {
        return new Promise<void>(resolve => {
            if (withOverlay) {
                gsap.killTweensOf(this._overlayGraphics);
                gsap.to(this._overlayGraphics, {
                    duration: 0.32, alpha: 1, onComplete: async () => {

                        display.alpha = 1;
                        const container = new Container();

                        this.display.addChild(container);
                        this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);

                        container.addChild(display);
                        container.alpha = 1;
                        container.scale.set(1);

                        gsap.to(container.scale, { x: 0.8, y: 0.8, duration: .3, ease: 'circ.in' });
                        gsap.to(container, {
                            alpha: 0, duration: .3, ease: 'circ.in', onComplete: async () => {
                                this.display.addChild(display);
                                this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);
                                this.display.removeChild(container);

                                resolve();
                            },
                        });
                    },
                });
            } else {
                this._overlayGraphics.alpha = 0;

                display.alpha = 1;
                const container = new Container();

                this.display.addChild(container);
                this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);

                container.addChild(display);
                container.alpha = 1;
                container.scale.set(1);

                gsap.to(container.scale, { x: 0.8, y: 0.8, duration: .3, ease: 'circ.in' });
                gsap.to(container, {
                    alpha: 0, duration: .3, ease: 'circ.in', onComplete: async () => {
                        this.display.addChild(display);
                        this.display.setChildIndex(this._overlayGraphics, this.display.children.length - 1);
                        this.display.removeChild(container);

                        resolve();
                    },
                });
            }
        });
    }
}
